import React, { useRef } from 'react';
import { ScrollSwapLine } from './ScrollSwapLine';
import { LogoWall } from './LogoWall';

/**
 * The agency tagline, centered between "Let's make them feel something" and the statement.
 * Blurs over to the collaborations line once scrolled halfway up; the rotating client logo row sits below it.
 */
export function AgencyTagline() {
  const lineRef = useRef<HTMLParagraphElement>(null);
  return <div id="clients" className="relative flex w-full flex-col items-center text-center" data-id="element-7" data-mp="3v2tk6nv72r95">
      {/* Phones: swaps 10% of the screen later, and the first line reads
          "We're an AI-first / Branding & Creative Agency" */}
      <ScrollSwapLine ref={lineRef} from="We’re a 3D Brand & Web Creative Agency" to="43 brand experiences in 5 years." mobileSwapAt={0.34} mobileBreakFromAfter={2} data-id="element-8" data-mp="3m4zpfhd2w5o3" />
      <LogoWall triggerRef={lineRef} data-id="element-9" data-mp="1k9pgldx3tcsq" />
    </div>;
}